import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '400px' }]

export default function SplashScreenAvatar({
  src,
  isExists,
  flip,
  isMobile,
  isAwsImage,
}: {
  src: string
  isExists: boolean
  flip?: boolean
  isMobile?: boolean
  isAwsImage?: boolean
}): React.ReactElement {
  const { t } = useTranslation('avatar')
  const avatarClassName = 'relative object-contain w-87.5 h-87.5'
  const mediaQueryTransparent = [{ screen: '(min-width: 280px)', width: `${isMobile ? 300 : 360}px` }]
  if (!isExists) {
    return (
      <ResponsiveImage
        alt={t('yourAvatar')}
        height={360}
        imageClassName={`${avatarClassName}  max-w-70 -mt-4 sm:min-w-75 sm:mt-0 ${flip ? 'scale-x-[-1]' : ''}`}
        imageWidths="360"
        mediaQuery={mediaQueryTransparent}
        srcKey="avatars/custom/default/Profile-transparent_Kim_v4.png"
        width={360}
      />
    )
  }

  if (isAwsImage) {
    return (
      <ResponsiveImage
        alt={t('yourAvatar')}
        imageClassName={`${avatarClassName} ${isMobile ? 'max-w-80 -mt-8 ' : 'min-w-75 '} ${
          flip ? 'scale-x-[-1]' : ''
        }`}
        src={src}
        width={360}
      />
    )
  }

  return (
    <ResponsiveImage
      alt={t('yourAvatar')}
      height={360}
      imageClassName={`${avatarClassName} ${isMobile ? 'max-w-80 -mt-8 ' : 'min-w-75 '} ${flip ? 'scale-x-[-1]' : ''}`}
      imageWidths="400"
      mediaQuery={mediaQuery}
      srcKey={src}
      width={isMobile ? 130 : 360}
    />
  )
}
